export default "__VITE_ASSET__BUJC6CAx__"